<template lang="html">
    <BaseWidget>
        <template slot="title">{{ $t("dashboardModule.myOrdersTitle") }}</template>
        <template slot="content-desktop"
            ><OrderList
        /></template>
        <template slot="content-mobile"
            ><OrderList
        /></template>
        <template slot="footer">
            <LinkButton :to="'/orders'" :text="$t('dashboardModule.seeAllOrders')" />
        </template>
    </BaseWidget>
</template>

<script lang="js">
import OrderList from "@/components/orders/order-common/order-list"
import BaseWidget from "@/components/dashboard/BaseWidget";
import LinkButton from "@/components/dashboard/elements/LinkButton";

export default  {
    components: { LinkButton, OrderList, BaseWidget}
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
</style>



// WEBPACK FOOTER //
// MyOrdersWidget.vue?9912939c